export default __webpack_public_path__ + "static/media/lucas_garmo.bd976144.jpeg";